const randomData =
  [
    {
      "id": "1",
      "title": "Listen to the audio and fill in blank the missing word",
      "subTitle": "Nghe và điền từ còn thiếu vào chỗ trống",
      "type": "FillWordInTheBlank",
      "option": null,
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/decorate/decorate.mp3",
      "answers": [
        {
          "id": 1,
          "text": "They decorated the room with flowers and balloons.",
          "answer": "decorate"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type4"
    },
    {
      "id": "2",
      "title": "Listen to the audio and fill in blank the missing word",
      "subTitle": "Nghe và điền từ còn thiếu vào chỗ trống",
      "type": "FillWordInTheBlank",
      "option": null,
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/wednesday/wednesday.mp3",
      "answers": [
        {
          "id": 1,
          "text": "He doesn't like Wednesday.",
          "answer": "Wednesday"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type4"
    },
    {
      "id": "3",
      "title": "Match the sound with correct words",
      "subTitle": "Nối âm với từ tương ứng",
      "type": "Matching",
      "option": null,
      "question": null,
      "imageUrl": null,
      "audioUrl": null,
      "answers": [
        {
          "id": 1,
          "answer": "jump",
          "isCorrect": "true",
          "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/jump/jump.mp3"
        },
        {
          "id": 2,
          "answer": "build",
          "isCorrect": "true",
          "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/build/build.mp3"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type1"
    },
    {
      "id": "4",
      "title": "Match the sound with correct words",
      "subTitle": "Nối âm với từ tương ứng",
      "type": "Matching",
      "option": null,
      "question": null,
      "imageUrl": null,
      "audioUrl": null,
      "answers": [
        {
          "id": 1,
          "answer": "phone number",
          "isCorrect": "true",
          "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/phone-number/phone-number.mp3"
        },
        {
          "id": 2,
          "answer": "Saturday",
          "isCorrect": "true",
          "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/saturday/saturday.mp3"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type1"
    },
    {
      "id": "5",
      "title": "Listen and choose the correct sound",
      "subTitle": "(Nghe và chọn âm trong có từ)",
      "type": "OneChoice",
      "option": "MONOPHONIC",
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/saturday/saturday.mp3",
      "answers": [
        {
          "id": 1,
          "answer": "s",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "f",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "j",
          "isCorrect": "false"
        }
      ],
      "settings": {
        "answers": {
          "bulletType": "none",
          "direction": "horizontal"
        }
      },
      "notes": "SGK4-Type12"
    },
    {
      "id": "6",
      "title": "Listen and choose the correct sound",
      "subTitle": "(Nghe và chọn âm trong có từ)",
      "type": "OneChoice",
      "option": "MONOPHONIC",
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/violet/violet.mp3",
      "answers": [
        {
          "id": 1,
          "answer": "v",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "f",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "s",
          "isCorrect": "false"
        }
      ],
      "settings": {
        "answers": {
          "bulletType": "none",
          "direction": "horizontal"
        }
      },
      "notes": "SGK4-Type12"
    },
    {
      "id": "7",
      "title": "Listen and choose the correct number",
      "subTitle": "Nghe và chọn số đúng",
      "type": "OneChoice",
      "option": "NUMBERS",
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/14/14.mp3",
      "answers": [
        {
          "id": 1,
          "answer": "14",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "19",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "24",
          "isCorrect": "false"
        }
      ],
      "settings": {
        "answers": {
          "direction": "horizontal",
          "bulletType": "none"
        }
      },
      "notes": "SGK4-Type6"
    },
    {
      "id": "8",
      "title": "Choose the correct ordinal numbers.",
      "subTitle": "Chọn số thứ tự tương ứng",
      "type": "OneChoice",
      "option": "ORDINAL_NUMBERS",
      "question": "nine => ?",
      "imageUrl": null,
      "audioUrl": null,
      "answers": [
        {
          "id": 1,
          "answer": "ninth",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "twentieth",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "twenty-seventh",
          "isCorrect": "false"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type5"
    },
    {
      "id": "9",
      "title": "Listen, choose the correct pronunciation for ‘ed’.",
      "subTitle": "Nghe, chọn cách phát âm đúng của ‘ed’.",
      "type": "OneChoice",
      "option": "PHONETIC",
      "question": "",
      "imageUrl": "",
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/boiled/boiled.mp3",
      "answers": [
        {
          "id": 1,
          "Text": "Boiled",
          "answer": "/d/",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "Text": "Listed",
          "answer": "/id/",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "Text": "Worked",
          "answer": "/t/",
          "isCorrect": "false"
        }
      ],
      "settings": {
        "answers": {
          "bulletType": "none",
          "direction": "horizontal"
        }
      },
      "notes": "SGK4-Type13"
    },
    {
      "id": "10",
      "title": "Listen, choose the correct pronunciation for ‘ed’.",
      "subTitle": "Nghe, chọn cách phát âm đúng của ‘ed’.",
      "type": "OneChoice",
      "option": "PHONETIC",
      "question": "",
      "imageUrl": "",
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/jammed/jammed.mp3",
      "answers": [
        {
          "id": 1,
          "Text": "jammed",
          "answer": "/d/",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "Text": "appreciated",
          "answer": "/id/",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "Text": "Thanked",
          "answer": "/t/",
          "isCorrect": "false"
        }
      ],
      "settings": {
        "answers": {
          "bulletType": "none",
          "direction": "horizontal"
        }
      },
      "notes": "SGK4-Type13"
    },
    {
      "id": "11",
      "title": "Listen and choose the correct sound",
      "subTitle": "(Nghe và chọn âm trong có từ)",
      "type": "OneChoice",
      "option": "POLYPHONIC",
      "question": "",
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/later/later.mp3",
      "answers": [
        {
          "id": 1,
          "answer": "er",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "ir",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "ie",
          "isCorrect": "false"
        }
      ],
      "settings": {
        "answers": {
          "bulletType": "none",
          "direction": "horizontal"
        }
      },
      "notes": "SGK4-Type12"
    },
    {
      "id": "12",
      "title": " Choose the correct sentence.",
      "subTitle": "(Chọn câu đúng)",
      "type": "OneChoice",
      "option": "SENTENCES",
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/film/film.mp3",
      "answers": [
        {
          "id": 1,
          "answer": "My favourite film is Lion King.",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "My favourite film are Lion King.",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "My favourite film be Lion King.",
          "isCorrect": "false"
        },
        {
          "id": 4,
          "answer": "My favourite film being Lion King.",
          "isCorrect": "false"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type8"
    },
    {
      "id": "13",
      "title": " Choose the correct sentence.",
      "subTitle": "(Chọn câu đúng)",
      "type": "OneChoice",
      "option": "SENTENCES",
      "question": null,
      "imageUrl": null,
      "audioUrl": "https://cloud.softech.cloud/storage/Data/Vocabulary/Sounds/US_Azure/guitar/guitar.mp3",
      "answers": [
        {
          "id": 1,
          "answer": "I can play guitar.",
          "isCorrect": "true"
        },
        {
          "id": 2,
          "answer": "I can plays guitar.",
          "isCorrect": "false"
        },
        {
          "id": 3,
          "answer": "I can be playing guitar.",
          "isCorrect": "false"
        },
        {
          "id": 4,
          "answer": "I can plays guitar.",
          "isCorrect": "false"
        }
      ],
      "settings": null,
      "notes": "SGK4-Type8"
    },
    {
      "id": "14",
      "title": "Unscramble letters to make a completed words",
      "subTitle": "Sắp xếp lại các chữ cái để có từ đúng.",
      "type": "Unscramble",
      "option": "CHARACTER",
      "question": "acoustic",
      "imageUrl": "https://cloud.softech.cloud/admin/Uploads/Images/Vocabulary/131595.png",
      "audioUrl": "https://cloud.softech.vn/storage/media/english/us_pron/a/aco/acous/acoustic.mp3",
      "answers": "acoustic",
      "settings": {
        "question": {
          "shuffedType": "character"
        }
      },
      "notes": "SGK4-Type2"
    },
    {
      "id": "15",
      "title": "Unscramble letters to make a completed words",
      "subTitle": "Sắp xếp lại các chữ cái để có từ đúng.",
      "type": "Unscramble",
      "option": "CHARACTER",
      "question": "culture",
      "imageUrl": "https://cloud.softech.cloud/admin/Uploads/Images/Vocabulary/136162.png",
      "audioUrl": "https://cloud.softech.vn/storage/media/english/us_pron/c/cul/cultu/culture.mp3",
      "answers": "culture",
      "settings": {
        "question": {
          "shuffedType": "character"
        }
      },
      "notes": "SGK4-Type2"
    },
    {
      "id": "16",
      "title": "Unscramble letters to make a completed words",
      "subTitle": "Sắp xếp lại các chữ cái để có từ đúng.",
      "type": "Unscramble",
      "option": "CHARACTER",
      "question": "portfolio",
      "imageUrl": "https://cloud.softech.cloud/admin/Uploads/Images/Vocabulary/143332.png",
      "audioUrl": "https://cloud.softech.vn/storage/media/english/us_pron/p/por/portf/portfolio.mp3",
      "answers": "portfolio",
      "settings": {
        "question": {
          "shuffedType": "character"
        }
      },
      "notes": "SGK4-Type2"
    },
    {
      "id": "17",
      "title": "Unscramble letters to make a completed words",
      "subTitle": "Sắp xếp lại các chữ cái để có từ đúng.",
      "type": "Unscramble",
      "option": "CHARACTER",
      "question": "theater",
      "imageUrl": "https://cloud.softech.cloud/admin/Uploads/Images/Vocabulary/140942.png",
      "audioUrl": "https://cloud.softech.vn/storage/media/english/us_pron/e/eus/eus74/eus74534.mp3",
      "answers": "theater",
      "settings": {
        "question": {
          "shuffedType": "character"
        }
      },
      "notes": "SGK4-Type2"
    },
    {
      "id": "18",
      "title": "Unscramble letters to make a completed words",
      "subTitle": "Sắp xếp lại các chữ cái để có từ đúng.",
      "type": "Unscramble",
      "option": "CHARACTER",
      "question": "viewpoint",
      "imageUrl": "https://cloud.softech.cloud/admin/Uploads/Images/Vocabulary/141365.png",
      "audioUrl": "https://cloud.softech.vn/storage/media/english/us_pron/u/usv/usvie/usvienn005.mp3",
      "answers": "viewpoint",
      "settings": {
        "question": {
          "shuffedType": "character"
        }
      },
      "notes": "SGK4-Type2"
    },
    {
      "id": "19",
      "title": "Unscramble the words to make a meaningful sentence.",
      "subTitle": "Sắp xếp các từ để tạo thành câu hoàn chỉnh.",
      "type": "Unscramble",
      "option": "SENTENCES",
      "question": "He wants too much cheese in his pasta.",
      "imageUrl": null,
      "audioUrl": null,
      "answers": "He wants too much cheese in his pasta.",
      "settings": null,
      "notes": "SGK4-Type7"
    },
    {
      "id": "20",
      "title": "Unscramble the words to make a meaningful sentence.",
      "subTitle": "Sắp xếp các từ để tạo thành câu hoàn chỉnh.",
      "type": "Unscramble",
      "option": "SENTENCES",
      "question": "They can swim.",
      "imageUrl": null,
      "audioUrl": null,
      "answers": "They can swim.",
      "settings": null,
      "notes": "SGK4-Type7"
    },
    {
      "id": "21",
      "title": "Unscramble the words to make a meaningful sentence.",
      "subTitle": "Sắp xếp các từ để tạo thành câu hoàn chỉnh.",
      "type": "Unscramble",
      "option": "SENTENCES",
      "question": "We can stay at home today.",
      "imageUrl": null,
      "audioUrl": null,
      "answers": "We can stay at home today.",
      "settings": null,
      "notes": "SGK4-Type7"
    }
  ]
export default randomData;
